'use strict';

function LicenseInfoController() {
	'ngInject';
	$(window).trigger('resize'); // ensure footer is properly positioned
}

module.exports = LicenseInfoController;
